import React from 'react'
import { useRef, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams, useNavigate } from 'react-router-dom';
import instance from '../../axios';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setAnnouncement } from '../../redux/reducers/announcementSlice';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Modal from '../help/help';
import CustomAlert from '../custom-alert';
import { Button, CardMedia, Typography } from '@mui/material';
import { baseUrl } from '../../axios';
import CustomProgressBar from '../customProgressBar/CustomProgressBar';
import CopyToClipboard from 'react-copy-to-clipboard';
import { formatPhoneNumber } from '../../functions';
 

function Announcement() {
      const { id } = useParams();
      const navigate = useNavigate();
      const [loading, setLoading] = useState(true);
      const [error, setError] = useState(false);
      const [modalShow, setModalShow] = useState(false);
      const [requests, setRequests] = useState([]);
      const [currMosque, setCurrMosque] = useState({});
      const [isCopied, setIsCopied] = useState(false);
    
      const { adInfo } = useSelector((state) => state.announcement);
    
      const dispatch = useDispatch();
    
      // -------------this code is used to control telegram's button----------------------///
      const ToTelegram = () => {
        // let obj = { adId: id, isMoney: true, command: "help" };
        // window.Telegram.WebApp.sendData(JSON.stringify(obj));
        // window.Telegram.WebApp.close();
        // window.location.href = `tel:+${currMosque.phone}`;
        // window.Telegram.WebApp.openLink(`tel:+${currMosque.phone}`);
        // window.TelegramWebviewProxy.postEvent("web_app_open_link", "+998901234567");
        copyToClipboard();
      };
      window.Telegram.WebApp.onEvent("mainButtonClicked", () => ToTelegram());
      window.Telegram.WebApp.MainButton.onClick = ToTelegram;
      // -----------------------------///
      const inputRef = useRef(null);
      
      const copyToClipboard = () => {
        inputRef.current.select();
        document.execCommand("copy");
        
        handleCopyClick(setIsCopied);
        tostify()
      };
  // -----------------------------///
  useEffect(() => {
      if (id !== undefined) {
        instance
          .get(`api/ads/${id}`)
          .then((res) => {
            setLoading(false);
            dispatch(setAnnouncement(res.data.data.ad));
            getMosqueInfo(res.data.data.ad.mosque_id);
          })
          .catch((err) => !err.response.data.ok && setError(true));
      }
    }, [id]);
  
    const getMosqueInfo = async (id) => {
      try {
        const response = await instance.get(`api/mosques/${id}`);
        setCurrMosque(response?.data?.data?.mosque);
      } catch (err) {
        console.log(err);
      }
    };
  
    //////////////////////////////////////
    // Get mosque ads
    useEffect(() => {
      if (id) {
        instance.get(`api/reqs?ad_id=${id}`).then((res) => {
          setRequests(res.data.data.requests);
        });
      }
    }, [id]);      
  //////////////////////////////////////

  // calculate dates range
  const getDateRange = () => {
      const start = new Date(adInfo?.created_at);
      const end = new Date();
      const diff = end.getTime() - start.getTime();
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      return days;
    };
  
  ////////////////////////////////////
  function handleProgress(array) {
      let compoletedAmount = 0;
      let onProgressAmount = 0;
      array.forEach((item) => {
        if (item.status === 3) {
          compoletedAmount += item.amount;
        }
        if (item.status === 2) {
          onProgressAmount += item.amount;
        }
      });
  
      return { compoletedAmount, onProgressAmount };
    }
  
    function handleAmount(array) {
      let amount = 0;
      array.forEach((item) => {
        if (item.status === 3) {
          amount += item.amount;
        }
      });
      return amount;
    }
  
    function handleCopy() {
      tostify();
    }
  /////////////////////////////////////////////////////////////////////////////////////////
  function tostify() {
      toast.info("Nusxa olindi!", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
      /////////////////////////////////////////////////////////////////////////////////////////
  function handleCopyClick(fn) {
      fn(true);
  
      // Hide the alert after 3 seconds
      setTimeout(() => {
        fn(false);
      }, 5000);
    }

       /////////////////////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////////////////////
  if (loading) {
      return (
        <div className="container mx-auto p-2">
          <h1 className="text-3xl text-gray-400 text-center">yuklanmoqda...</h1>
        </div>
      );
    }
  
    if (error) {
      return (
        <div className="container mx-auto p-2">
          <h1 className="text-3xl text-red-600 text-center">Mavjud emas...</h1>
        </div>
      );
    }

  return (
      <>
        {/* <ToastContainer/> */}
      <div className="container mx-auto">
        <CustomAlert isCopied={isCopied} setIsCopied={setIsCopied} />
        <input
          type="text"
          defaultValue={"+" + currMosque.phone}
          value={"+" + currMosque.phone}
          ref={inputRef}
          style={{ position: "absolute", zIndex: "-999", left: "-100%" }}
        />
        <Modal
          show={modalShow}
          oncancel={() => {
            setModalShow(false);
          }}
        />
        <div className="mx-auto  h-screen flex flex-col justify-between ">
          {/* <h1 className="mb-3 text-2xl text-center">E'lon</h1> */}
          <div>
            <CardMedia
              component="img"
              // height="140"
              image={
                adInfo?.image_src
                  ? `${baseUrl}files/${adInfo?.image_src}`
                  : "/images/mosque-contruction.jpg"
              }
              alt="green iguana"
              style={{ objectFit: "cover", maxHeight: "210px" }}
            />
            <div className="go-back-btn">
              <Button className="ortga" onClick={() => navigate(-1)}>
                <img
                  src="../../images/angle-left-solid.svg"
                  alt="icon"
                  className="img-back mr-2"
                  width={"13"}
                  height={"13"}
                />
                Ortga
              </Button>
            </div>
            <div className=" overflow-hidden  bg-white shadow-md duration-200  ">
              <div className="p-5">
                <p className="mb-[20px]">
                  <span className="text-black text-xl font-medium">
                    {adInfo.name}
                  </span>
                </p>
                <CustomProgressBar
                  completed={handleProgress(requests).compoletedAmount}
                  inProgress={handleProgress(requests).onProgressAmount}
                  total={adInfo?.amount}
                />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{ display: "flex" }}>
                  <span className="font-bold text-black">
                    {handleAmount(requests) | 0}
                  </span>
                  /{+adInfo?.amount} {adInfo?.amount_type}{" "}
                  {adInfo?.category?.name.toLowerCase()} yig'ildi
                  <span className="flex items-center font-normal charity-count">
                    {adInfo?.requests?.length} ehson
                  </span>
                </Typography>
                <Typography
                  variant="body1"
                  marginY={2}
                  color="#333333"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}>
                  {/* <LocationOnIcon style={{ width: "15px" }} /> */}
                  <img
                    src="../../images/icon-location.svg"
                    alt="icon"
                    className="w-[36px] h-[36px] mr-2"
                  />
                  <Link
                    to={`/mosque-info/${adInfo?.mosque?.id}`}
                    style={{ borderBottom: "1px dashed #666666" }}>
                    {`${adInfo?.mosque?.name}, ${adInfo?.mosque?.location}`}
                  </Link>
                </Typography>
                <CopyToClipboard text={"+" + currMosque.phone}>
                  <div
                    className="relative my-[14px] text-[#1976D2] underline day-text flex cursor-pointer"
                    onClick={handleCopy}>
                    {formatPhoneNumber(currMosque.phone)}
                  </div>
                </CopyToClipboard>

                <hr />
                {/* <p className="my-[14px] text-[#4D4D4D] day-text flex">
                  {getDateRange()} kun oldin
                  <span
                    onClick={() => navigate(-1)}
                    className=" cursor-pointer flex items-center text-[#1976D2] underline font-normal">
                    {adInfo?.category?.name}
                  </span>
                </p>
                <hr className="mb-[12px]" /> */}
                <p className="mb-2" onClick={copyToClipboard}>{adInfo.text}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Announcement